module.exports = __webpack_public_path__ + "img/bay.1c03574c.svg";